import { apiFetchWeb } from "@/hooks/apiFetchWeb"

type AddToCartData = {
  product_id: number
  quantity: number
  options?: any
}

type UpdateQuantityData = {
  quantity: number
}

export const cartService = {
  getCart: async (signal?: AbortSignal) =>
    apiFetchWeb("cart", {
      signal,
    }),
  addItem: async (data: AddToCartData) =>
    apiFetchWeb("cart/items", {
      method: "POST",
      body: JSON.stringify(data),
    }),
  removeItem: async (cartItemId: number) =>
    apiFetchWeb(`cart/items/${cartItemId}`, {
      method: "DELETE",
    }),
  updateQuantity: async (cartItemId: number, data: UpdateQuantityData) =>
    apiFetchWeb(`cart/items/${cartItemId}/quantity`, {
      method: "PUT",
      body: JSON.stringify(data),
    }),
  clear: async () =>
    apiFetchWeb("cart/clear", {
      method: "DELETE",
    }),
  checkout: async () =>
    apiFetchWeb("cart/checkout", {
      method: "POST",
    }),
}
